import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-inbuilt-visual',
    templateUrl: './inbuilt-visual.component.html',
    styleUrl: './inbuilt-visual.component.scss',
    imports: [MatIcon]
})
export class InbuiltVisualComponent {
  @Input() disabled = false;
  @Output() addVisual = new EventEmitter<void>();
}
